<template>
  <router-view/>
</template>

<style>
#app {
  font: normal 14px Arial, "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666;
  height: 100%;
  /* padding: 20px 20px 0 20px; */
  margin: 0px auto;
  position: relative;
}
.el-main {
  padding: 0;
  margin: 10px 50px;
}
.el-footer {
  padding: 0;
}
.ellipsis {
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
  width: 100%;             /* 必须指定宽度（或max-width）*/
  display: block;           /* 对于行内元素需要设置为块级或inline-block */
}
a {
    color: #0e0e0f;
    text-decoration-line: none;
}
</style>
